<template>
    <div>
        <banner heading="LOGIN" description="LOGINDESCRIPTION" type="login"></banner>

        <div class="container login">
            <form action="/login" method="post" id="login-form" v-on:submit.prevent>
                <div class="form-group">
                    <label for="login-email">{{ $t('EMAIL') }}</label>
                    <b-form-input v-model="login.email"
                                  id="login-email"
                                  type="email"
                                  required
                                  :state="login.email.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <label for="login-password">{{ $t('PASSWORD') }}</label>
                    <b-form-input v-model="login.password"
                                  type="password"
                                  id="login-password"
                                  required
                                  :state="login.password.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary" type="submit" @click="handleLogin">{{ 'LOGIN' | translate }}</button>
                </div>
            </form>
            <div class="alert alert-info" v-if="error !== false">{{ error | translate }}</div>
        </div>
    </div>
</template>

<script>
import AuthService from '../services/auth.service';
import banner from './Banner.vue';

export default {
    name:    'login',
    data() {
        let error = false;
        return {
            login: {
                email:    '',
                password: ''
            },
            error
        };
    },
    methods: {
        handleLogin() {
            const auth = new AuthService();
            auth.login(this.login)
                .then(() => {
                    this.$router.push({ path: '/' });
                })
                .catch(err => {
                    if (err.response) {
                        this.error = err.response.data.message;
                        return err.response;
                    }
                });
        },
        failed(errors) {
            console.log('failed ', errors);
        },
        logout() {
            this.$cookie.delete('token');
        }
    },
    components: {
        banner
    }
};
</script>
